export default __webpack_public_path__ + "static/media/svg-map.80f08cb0.svg";